import { defineStore } from 'pinia';
import { v4 as uuidv4 } from 'uuid';
import api from '@/services/api';
import resource_model from '@/views/resource/models/resource_model.js';
import initial_resource_filters from '@/views/resource/models/initial_resource_filter_model.js';
import { getParamsUrl } from '@/views/resource/resource_utils.js';
import recurso_service from '@/services/recurso_service';

export const useRecursoStore = defineStore('recursoStore', {
  state: () => ({
    recursoList: [],
    recursoFilteredList: [],
    recurso: JSON.parse(JSON.stringify(resource_model)),
    page: 1,
    filters: { ...initial_resource_filters },
    validateResourceFields: {
      Descripcion: true,
      RecursoTipo: true,
    },
  }),
  actions: {
    resetValidations() {
      // Resetear cada campo de validación al estado inicial
      Object.keys(this.validateResourceFields).forEach((key) => {
        this.validateResourceFields[key] = true;
      });
    },
    validarCampos() {
      this.validateResourceFields.Descripcion = !!this.recurso.Descripcion;
      this.validateResourceFields.RecursoTipo = !!this.recurso.CodigoRecursoTipo;
      return this.validateResourceFields.RecursoTipo && this.validateResourceFields.Descripcion;
    },
    async findRecursosByProcesoHTTP(filtersProcesos = {}, indexProceso) {
      try {
        const result = await recurso_service.findByProceso(filtersProcesos);
        if (result && result.data) {
          this.recursoFilteredList[indexProceso] = result.data;
          return true;
        }
        return false;
      } catch (error) {
        console.error('Error en findRecursosByProcesoHTTP:', error);
        return false;
      }
    },
    async findAllRecursoHTTP() {
      try {
        const params = getParamsUrl({ ...this.filters, limit: this.limit || 35, page: +this.page });
        const result = await recurso_service.findAll(params);
        if (result && result.data && result.data.length > 0) {
          this.recursoList.push(...result.data);
          this.setPage(this.page + 1);
          return true;
        }
        return false;
      } catch (error) {
        console.error('Error en findAllRecursoHTTP:', error);
        return false;
      }
    },
    async findAndReturnAllRecursoHTTP(params) {
      try {
        const queryParams = getParamsUrl({ ...this.filters, ...params });
        const result = await recurso_service.findAll(queryParams);
        if (result && result.data && result.data.length > 0) {
          return result.data;
        }
        return [];
      } catch (error) {
        console.error('Error en findAndReturnAllRecursoHTTP:', error);
        return [];
      }
    },

    async firstRecurso() {
      this.setPage(1);
      this.emptyList();
      await this.findAllRecursoHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.recursoList = [];
    },
    resetResource() {
      this.recurso = JSON.parse(JSON.stringify(resource_model));
    },
    resetFilter() {
      this.filters = { ...initial_resource_filters };
    },
    async newResourceHTTP({ file } = {}) {
      try {
        const usuarioStr = localStorage.getItem('usuario');
        if (usuarioStr) {
          const usuarioObj = JSON.parse(usuarioStr);
          this.recurso.CodigoUsuarioCreacion = usuarioObj?.Codigo;
        }
        if (!this.recurso.CodigoMoneda && this.recurso.Moneda?.Codigo) {
          this.recurso.CodigoMoneda = this.recurso.Moneda.Codigo;
        }

        let response;

        if (file) {
          const fd = new FormData();
          const ALLOWED = [
            'Descripcion',
            'CodigoRenglonEquivalente',
            'CostoHora',
            'CodigoRecursoTipo',
            'CodigoMoneda',
            'CantidadColor',
            'TiempoPreparacionColor',
            'TiempoPolimero',
            'MermaPolimero',
            'AnchoMaximo',
            'LargoMaximo',
            'LargoMaximoPlatina',
            'PasoPlatina',
            'CantidadCuerposImpresores',
            'Activo',
            'CodigoUsuarioCreacion',
          ];

          for (const key of ALLOWED) {
            const val = this.recurso[key];
            if (val === undefined || val === null) continue;
            if (typeof val === 'string' && val.trim() === '') continue;
            fd.append(key, String(val));
          }

          fd.append('file', file);
          response = await recurso_service.create(fd);
        } else {
          const payload = { ...this.recurso };
          delete payload.Codigo;
          delete payload.FechaCreacion;
          delete payload.FechaActualizacion;
          delete payload.CodigoUsuarioActualizacion;
          delete payload.Moneda;
          delete payload.RecursoTipo;

          response = await recurso_service.create(payload);
        }

        if (response.status === 200 || response.status === 201) {
          this.resetResource();
          return true;
        }
        return false;
      } catch (error) {
        console.error('Error en newResourceHTTP:', error);
        return false;
      }
    },
    async updateResourceHTTP({ file, removeImage } = {}) {
      const usuarioStr = localStorage.getItem('usuario');
      if (usuarioStr) {
        const u = JSON.parse(usuarioStr);
        this.recurso.CodigoUsuarioActualizacion = u?.Codigo;
      }

      if (this.recurso?.Moneda?.Codigo) {
        this.recurso.CodigoMoneda = this.recurso.Moneda.Codigo;
      }
      if (!this.recurso.CodigoRecursoTipo && this.recurso.RecursoTipo?.Codigo) {
        this.recurso.CodigoRecursoTipo = this.recurso.RecursoTipo.Codigo;
      }

      let response;
      if (file || removeImage) {
        const fd = new FormData();
        const ALLOWED = [
          'Descripcion',
          'CodigoRenglonEquivalente',
          'CostoHora',
          'CodigoRecursoTipo',
          'CodigoMoneda',
          'CantidadColor',
          'TiempoPreparacionColor',
          'TiempoPolimero',
          'MermaPolimero',
          'AnchoMaximo',
          'LargoMaximo',
          'LargoMaximoPlatina',
          'PasoPlatina',
          'CantidadCuerposImpresores',
          'Activo',
          'CodigoTipoCilindro',
          'Colores',
          'CodigoUsuarioActualizacion',
        ];
        for (const k of ALLOWED) {
          const v = this.recurso[k];
          if (v === undefined || v === null) continue;
          if (typeof v === 'string' && v.trim() === '') continue;
          fd.append(k, String(v));
        }

        // AtributosAdicionales ya viene como objeto desde el formulario
        if (this.recurso.AtributosAdicionales) {
          fd.append('AtributosAdicionales', JSON.stringify(this.recurso.AtributosAdicionales));
        }

        const procesos = Array.isArray(this.recurso?.ProcesoRecurso)
          ? this.recurso.ProcesoRecurso
          : [];
        const procesosPayload = procesos.map((p) => ({
          CodigoProceso: p.CodigoProceso ?? p.Proceso?.Codigo ?? null,
          CodigoRecurso: this.recurso.Codigo,
          CodigoCosto: p.CodigoCosto ?? p.Costo?.Codigo ?? null,
          Velocidad: Number(p.Velocidad ?? 0),
          TiempoAjuste: Number(p.TiempoAjuste ?? 0),
          MermaFija: Number(p.MermaFija ?? 0),
          CodigoUnidadMedida: p.CodigoUnidadMedida ?? p.UnidadMedida?.Codigo ?? null,
          MermaPorcentaje: Number(p.MermaPorcentaje ?? 0),
          Realimentacion: p.Realimentacion !== null ? Number(p.Realimentacion) : null,
          TiempoRecarga: p.TiempoRecarga !== null ? Number(p.TiempoRecarga) : null,
          UsaDesarrollo: p.UsaDesarrollo ?? false,
        }));

        const procesosValidos = procesosPayload.filter(
          (x) => x.CodigoProceso && x.CodigoRecurso && x.CodigoCosto,
        );

        if (procesos.length) {
          fd.append('ProcesoRecurso', JSON.stringify(procesosValidos));
        }
        if (file) fd.append('file', file);
        if (removeImage !== null) fd.append('removeImage', String(!!removeImage));

        response = await recurso_service.update(this.recurso.Codigo, fd);
      } else {
        const payload = { ...this.recurso };
        if (Array.isArray(payload.ProcesoRecurso)) {
          const procesosPayload = payload.ProcesoRecurso.map((p) => ({
            CodigoProceso: p.CodigoProceso ?? p.Proceso?.Codigo ?? null,
            CodigoRecurso: payload.Codigo,
            CodigoCosto: p.CodigoCosto ?? p.Costo?.Codigo ?? null,
            Velocidad: Number(p.Velocidad ?? 0),
            TiempoAjuste: Number(p.TiempoAjuste ?? 0),
            MermaFija: Number(p.MermaFija ?? 0),
            CodigoUnidadMedida: p.CodigoUnidadMedida ?? p.UnidadMedida?.Codigo ?? null,
            MermaPorcentaje: Number(p.MermaPorcentaje ?? 0),
            Realimentacion: p.Realimentacion !== null ? Number(p.Realimentacion) : null,
            TiempoRecarga: p.TiempoRecarga !== null ? Number(p.TiempoRecarga) : null,
            UsaDesarrollo: p.UsaDesarrollo ?? false,
          })).filter((x) => x.CodigoProceso && x.CodigoRecurso && x.CodigoCosto);

          payload.ProcesoRecurso = procesosPayload;
        }
        delete payload.Moneda;
        delete payload.RecursoTipo;

        // AtributosAdicionales ya viene como objeto desde el formulario
        // Se envía directamente al backend

        response = await recurso_service.update(this.recurso.Codigo, payload);
      }

      if (response.status === 200) {
        this.resetResource();
        return true;
      }
      return false;
    },
    async findResourceByCodigoHTTP(codigo) {
      try {
        const result = await recurso_service.findByCodigo(codigo);
        if (result && result.data) {
          let recurso;

          if (result.data.ProcesoRecurso && result.data.ProcesoRecurso.length > 0) {
            recurso = {
              ...result.data,
              ProcesoRecurso: result.data.ProcesoRecurso.map((p) => ({ ...p, id: uuidv4() })),
            };
          } else {
            recurso = { ...result.data, ProcesoRecurso: [] };
          }

          // El backend devuelve AtributosAdicionales como objeto
          // Asegurar que esté inicializado
          if (!recurso.AtributosAdicionales) {
            recurso.AtributosAdicionales = {};
          }

          this.recurso = JSON.parse(JSON.stringify(recurso));
        }
      } catch (error) {
        console.error('Error en findResourceByCodigoHTTP:', error);
      }
    },
    async cloneResourceHTTP(codigo) {
      try {
        const result = await api.post(`/recurso/recurso-clone/${codigo}`);
        return result.data;
      } catch (error) {
        console.error('Error en cloneResourceHTTP:', error);
        throw error;
      }
    },
    addProcess(process) {
      this.recurso.ProcesoRecurso.push(process);
      console.log(this.recurso.ProcesoRecurso);
    },
    async updateRecursoCostosHTTP(costos) {
      try {
        const response = await api.patch('/recurso/recursos-costos', { costos });

        if (response && response.data) {
          const { recursos } = response.data;

          recursos.forEach((updated) => {
            const idx = this.recursoList.findIndex((r) => r.Codigo === updated.Codigo);
            if (idx !== -1) {
              this.recursoList[idx].CostoHora = updated.CostoHora;
            }
          });
        }
        return response.data;
      } catch (error) {
        console.error('Error al actualizar costos masivos:', error);
        throw error;
      }
    },
    deleteProcess(process) {
      const index = this.recurso.ProcesoRecurso.findIndex((p) => p.id === process.id);
      console.log(index, process, this.recurso.ProcesoRecurso);
      this.recurso.ProcesoRecurso.splice(index, 1);
    },
    setCodigoMoneda(codigoMoneda) {
      this.recurso.CodigoMoneda = codigoMoneda ?? null;
      if (this.recurso.Moneda && this.recurso.Moneda.Codigo !== codigoMoneda) {
        this.recurso.Moneda = null;
      }
    },
  },
});
